var _circle, _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLvn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3426_34161",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3426_34161)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3426_34161)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: -0.5,
    r: 11.5,
    fill: "#6D98CE"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3426_34161)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 9,
    r: 7,
    fill: "#B383AC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3426_34161)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -1.5,
    cy: 18.5,
    r: 12.5,
    fill: "#42259D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3426_34161)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 3.5,
    r: 7.5,
    fill: "#5057C6"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_3426_34161)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 21,
    r: 11,
    fill: "#761D58"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3089 14.5L11.9999 3.88208L6.69098 14.5H5.5L5 15.5H6.19098L5.19092 17.5001H18.809L17.8089 15.5H19L18.5 14.5H17.3089ZM16.1909 14.5L11.9999 6.11815L7.80901 14.5H16.1909ZM16.6909 15.5H7.30901L6.80895 16.5001H17.1909L16.6909 15.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3426_34161",
    x: -7,
    y: -18,
    width: 35,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_3426_34161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3426_34161",
    x: 8,
    y: -4,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_3426_34161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3426_34161",
    x: -20,
    y: 0,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_3426_34161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3426_34161",
    x: -11,
    y: -10,
    width: 27,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_3426_34161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3426_34161",
    x: 3,
    y: 4,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_3426_34161"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLvn);
export default __webpack_public_path__ + "static/media/lvn.d4e842b3b77f747ca47254927e4cc900.svg";
export { ForwardRef as ReactComponent };